// Add one entry per completed Worship Night. Media paths should point to files
// in public; video entries should use browser-supported formats such as MP4.
const worshipNightArchive = [];

export default worshipNightArchive;
